export default __webpack_public_path__ + "static/universcape_background-a011792b812fd181ae4f52f9446becf5.webp";